<app-navbar-style-two></app-navbar-style-two>

<!-- MAIN CONTENT -->
<section class="projects-section">
  <div class="container">

  <div class="hero-inner">
        <h2 class="hero-title">Blog</h2>
           <!-- <nav class="breadcrumb-container" style="margin:   0px 25px 0px ;">
            <a routerLink="/" class="breadcrumb-link">Home</a>
            <span class="breadcrumb-separator">/</span>
            <span class="breadcrumb-current">Blog</span>
        </nav> -->
    </div>

    <!-- CATEGORY FILTER TABS -->
<div class="filter-wrapper">
  <!-- <button class="nav-arrow left" (click)="scrollFilter('left')">❮</button> -->

  <div class="category-bar" #categoryBar>
    <button class="cat-btn" [class.active]="selectedCategory === ''"
            (click)="onCategorySelect('')">
      <i class="bx bx-dish"></i> ALL BLOGS
    </button>
    <button *ngFor="let cat of categories"
            class="cat-btn"
            [class.active]="selectedCategory == cat.id"
            (click)="onCategorySelect(cat.id)">
      <i class="bx bx-category"></i> {{ cat.category_name | uppercase }}
    </button>
  </div>

  <!-- <button class="nav-arrow right" (click)="scrollFilter('right')">❯</button> -->
</div>

    <!-- BLOG LIST -->
    <div class="blog-grid-container">

      <ng-container *ngIf="singleBlogPost.length > 0; else emptyState">
        <div class="blog-grid">
          <div
            *ngFor="let item of singleBlogPost; let i = index"
            class="blog-card"
            [class.even]="i % 2 === 1">

            <!-- IMAGE -->
            <div class="blog-card-image">
              <img
                [src]="item.img"
                [alt]="item.title">
              <div class="blog-card-overlay">
                <a routerLink="/{{item.detailsLink}}" class="read-more-btn">
                  Read More
                </a>
              </div>
            </div>

            <!-- CONTENT -->
            <div class="blog-card-content">
              <div class="blog-card-meta">
                <span class="blog-date">
                  <i class='bx bx-calendar'></i>
                  {{ item.created_at | date:'dd MMM yyyy' }}
                </span>
                <span class="blog-category">
                  <i class='bx bx-category'></i>
                  {{ item.category_name || 'Blog' }}
                </span>
              </div>

              <h3 class="blog-card-title">
                <a routerLink="/{{item.detailsLink}}">{{ item.title }}</a>
              </h3>

              <p class="blog-card-excerpt">{{ item.paragraph }}</p>

              <div class="blog-card-footer">
                <a routerLink="/{{item.detailsLink}}" class="blog-card-link">
                  Read More
                  <i class='bx bx-right-arrow-alt'></i>
                </a>
              </div>
            </div>

          </div>
        </div>
      </ng-container>

      <!-- EMPTY STATE -->
      <ng-template #emptyState>
        <div class="empty-state">
          <div class="empty-icon">📝</div>
          <h3>No blogs found</h3>
          <p>No articles available in this category right now.</p>
        </div>
      </ng-template>

    </div>

    <!-- PAGINATION -->
    <div class="pagination-wrapper" *ngIf="totalPages > 1">
        <button class="pagination-btn" (click)="prevPage()" [disabled]="currentPage === 1">
            Previous
        </button>
        <span class="pagination-info">Page {{currentPage}} of {{totalPages}}</span>
        <button class="pagination-btn" (click)="nextPage()" [disabled]="currentPage === totalPages">
            Next
        </button>
    </div>

  </div>
</section>